import { Component, OnInit } from "@angular/core";

import { environment } from "@environments/environment";

@Component({
    selector: "app-settings",
    templateUrl: "./settings.component.html",
    styleUrls: ["./settings.component.scss"],
    standalone: false
})
export class SettingsPageComponent implements OnInit {
  constructor() {}
  public enablePublishing = environment.disableUI.enablePublishing || false;
  public enableCMS = environment.disableUI.enableCMS || false;

  ngOnInit(): void {}
}
